<template>
  <b-form-group :label="label || 'New Password'"
                label-class="text-truncate label-required"
                class="tw-relative">
    <b-form-input v-model="password"
                  type="password"
                  :debounce="300"
                  :name="name || 'password'"
                  required
                  :placeholder="placeholder"
                  :state="newPasswordValid"
                  @focus="newPasswordFocused = true"
                  @blur="newPasswordFocused = false"/>

    <div class="tw-inline-flex tw-absolute tw-right-0 tw-top-14 tw-z-10" v-if="showNewPasswordPopup">
      <div class="card tw-shadow-md">
        <div class="card-body p-3">
          <div class="tw-flex tw-flex-col">
            <div class="tw-font-medium tw-text-sm tw-mb-2">Password must:</div>

            <div class="tw-flex tw-flex-col tw-gap-1">
              <div v-for="item in newPasswordMessages"
                   class="tw-flex tw-items-center tw-gap-2"
                   :class="{ 'tw-text-green-500': item.valid, 'tw-text-red-500': !item.valid }">
                <i class="far"
                   :class="{ 'fa-check-circle': item.valid, 'fa-times-circle': !item.valid }"></i>
                <div class="tw-text-sm">{{ item.message }}</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </b-form-group>
</template>
<script>

import {UsersApi} from "../../Api/UsersApi";

export default {
  props: ['value', 'label', 'name', 'placeholder', 'email'],

  data() {
    return {
      newPasswordMessages: [],
      newPasswordFocused: false,
    }
  },
  computed: {
    newPasswordValid() {
      if (!this.password || !this.password.length) {
        return null;
      }

      if (this.newPasswordMessages && Array.isArray(this.newPasswordMessages) && this.newPasswordMessages.length) {
        return this.newPasswordMessages.every(item => item.valid);
      }

      return true
    },

    showNewPasswordPopup() {
      return this.password && this.password.length && !this.newPasswordValid && this.newPasswordFocused;
    },

    password: {
      get() {
        return this.value
      },
      set(pass) {
        this.$emit('input', pass)
      }
    }
  },

  watch: {
    async password(val) {
      const result = await UsersApi.verifyPassword(val, this.email)
      this.newPasswordMessages = result.data
    },

    newPasswordMessages(val) {
      this.$emit('newPasswordMessages', val)
    }
  },

  methods: {

  }
}
</script>